import React from 'react';
import { useTranslation } from 'react-i18next';
import RedWarningIcon from '../../../assets/icons/red-warning.svg';
import './ConfirmDeleteLinkModal.less';

export type ConfirmDeleteLinkModalProps = {
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmDeleteLinkModal: React.FC<ConfirmDeleteLinkModalProps> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => onCancel?.();
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  return (
    <div className="confirm-delete-link-overlay" onClick={handleOverlayClick}>
      <div className="confirm-delete-link-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>
        <div className="confirm-delete-link-container">
          <img src={RedWarningIcon} className="confirm-delete-link-icon" alt="Warning" />
          <div className="confirm-delete-link-title">{t('delete-link-confirm-title')}</div>
          <div className="confirm-delete-link-desc">{t('delete-link-confirm-desc')}</div>
          <button type="button" className="confirm-delete-button" onClick={onConfirm}>
            {t('confirm')}
          </button>
          <button type="button" className="confirm-cancel-button" onClick={onCancel}>
            {t('cancel')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteLinkModal;
